/**
 * @description Dialog functions used for showing dialogs/popups in published applications.
 */

import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';

import { EngineConfirmDialogs } from '@blaze-runtime/workflow-feature';
import {
  ConfirmDialogButton,
  ConfirmDialogButtonAction,
  MessageFormat,
} from '@blaze-shared/workflow-domain';

import { DialogConfirmComponent } from '../../components/dialog-confirm/dialog-confirm.component';

import { DialogBackdropService } from './dialog-backdrop.service';

@Injectable({ providedIn: 'root' })
export class ApplicationDialogService extends EngineConfirmDialogs {
  private readonly dialog = inject(MatDialog);
  private readonly dialogBackdropService = inject(DialogBackdropService);

  openConfirmDialog(
    title: string,
    message: string,
    buttons: ConfirmDialogButton[],
    messageFormat?: MessageFormat,
  ): Observable<ConfirmDialogButtonAction> {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      minWidth: '376px',
      maxWidth: '60vw',
      height: 'auto',
      hasBackdrop: true,
      backdropClass: 'bd-overlay-appearance',
      panelClass: ['bd', 'bd-dialog', 'with-theme'],
      data: { title, message, buttons, messageFormat },
    });

    // Style overlay with dialog/popup appearance configured in project appearance settings
    this.dialogBackdropService.attachBackdropStyles();
    return dialogRef.afterClosed() as Observable<ConfirmDialogButtonAction>;
  }
}
